// extracted by mini-css-extract-plugin
export default {"blockSelector":"style_blockSelector__Y8rWE","carouselContainer":"style_carouselContainer__gzTPi","uninteracted":"style_uninteracted__GFYrQ","breathe":"style_breathe__RViQI"};